import styled from '@emotion/styled';

export const FooterWrapper = styled.div`
  width: 100%;
  height: 30px;
  background-color: transparent;

  margin-top: 30px;
`;
